const getUserRank = (points) => {
  if (points <= 300) return "Code Blooded";
  if (points <= 500) return "Code Bender";
  if (points <= 800) return "Committer";
  if (points > 800) return "Lead Disruptor";
};

export default getUserRank;
